"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    listBackground: palette.elPrimary,
    listBorderColor: palette.elPrimary,
    listBoxShadow: "0 6px 10px 0 ".concat(palette.elShadow, ", 0 4px 10px 0 ").concat(palette.elShadow),
    itemFontSize: palette.tsNormal,
    itemLineHeight: 1.5,
    itemColor: palette.tActive,
    hoverItemBackground: palette.elLightest,
    focusItemBackground: palette.elLightest,
    activeItemBackground: palette.elLightest,
    width: 'auto',
    minWidth: 'auto'
  };
}